import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

const backendEndpoint = environment.backendEndpoint;

@Injectable({
  providedIn: 'root'
})
export class ClickerSummaryService {

  baseUrl2 =  '/api/v1/summary';
  endUrl   = '';

  constructor(private httpClient: HttpClient) {
    this.endUrl = backendEndpoint + this.baseUrl2;
  }

  getClickerSummary(criteria) {
    return this.httpClient.post<any>(this.endUrl + '/clicker', criteria, { observe: 'response' });
  }

}
